import { render } from "./InactivePlayerArea.vue?vue&type=template&id=92d6e1da&ts=true"
import script from "./InactivePlayerArea.vue?vue&type=script&lang=ts"
export * from "./InactivePlayerArea.vue?vue&type=script&lang=ts"

import "./InactivePlayerArea.vue?vue&type=style&index=0&id=92d6e1da&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__